import React from 'react';

import { css } from '@emotion/react';

import { Chip } from '@gumtree/ui-library/src';
import WithChildrenVisibilityDetector from '@gumtree/shared/src/util/element-visibility/children-visibility-detector';
import WithVisibilityObserver from '@gumtree/shared/src/util/element-visibility/visibility-observer';
import { gutterSizes } from '@gumtree/ui-library/src/base/theme';

export const Container = ({
    children,
    className,
}: React.PropsWithChildren & { className?: string }) => {
    return <div className={className}>{children}</div>;
};

export const StyledWithChildrenVisibilityDetector = ({
    children,
    onLoad,
}: React.PropsWithChildren & { onLoad: (total: number, hidden: number) => void }) => {
    const styles = css`
        display: flex;
        flex-wrap: nowrap;
        overflow-x: scroll;
        gap: ${gutterSizes.medium10};
        margin-top: ${gutterSizes.medium};

        ::-webkit-scrollbar {
            display: none; /* This hides the scrollbar */
        }
    `;

    return (
        <WithChildrenVisibilityDetector css={styles} onLoad={onLoad}>
            {children}
        </WithChildrenVisibilityDetector>
    );
};

export const StyledChipWithVisibilityObserver = ({
    label,
    onClick,
    onVisible,
}: {
    label: string;
    onClick: () => void;
    onVisible: (isVisibleOnLoad: boolean) => void;
}) => {
    const containerStyles = css`
        flex-shrink: 0; // Prevents the chip from wrapping to the next line
    `;

    return (
        <WithVisibilityObserver css={containerStyles} onVisible={onVisible} threshold={1}>
            <Chip onClick={onClick}>{label}</Chip>
        </WithVisibilityObserver>
    );
};
